import { AdjustmentFilter } from '@pixi/filter-adjustment';
function createNotInHandFilter() {
    const filter = new AdjustmentFilter();
    filter.contrast = 0.4;
    filter.brightness = 0.6;
    return filter;
}
export const NOT_IN_HAND_FILTER = createNotInHandFilter();
